import { Box, Skeleton } from "@mui/material";
import { DotLegalLink } from "@dotlegal/dotlegal-ui-components";
import { PurpleLockIcon } from "@common/icons.tsx";
import { useRelationsQuery } from "@common/hooks/Relations.hooks.ts";
import { useTranslation } from "@localization/useTranslation.ts";
import { usePlanContext } from "../../../auth/planProvider/PlanProvider.tsx";
import { useUrlProvider } from "../../../useUrlProvider.ts";
import { getLink } from "../../../taskManagement/taskPane/taskRelationsBox/TaskRelationsBox.hooks.ts";
import { useOverviewStepSectionStyles } from "./OverviewStepSection.styles.ts";

export interface OverviewRelationsFieldProps {
    entityId: string;
}

function OverviewRelationsField(props: OverviewRelationsFieldProps) {
    const { translateString } = useTranslation();
    const { platformFeatures } = usePlanContext();
    const urlProvider = useUrlProvider();
    const { isLoading, data } = useRelationsQuery(props.entityId);
    const styles = useOverviewStepSectionStyles();

    const getRelationNames = () => {
        if (isLoading) {
            return <Skeleton variant={"text"} />;
        }

        return (data ?? []).map((relation) => (
            <Box key={relation.relationId}>
                <DotLegalLink
                    linkColor={"primary"}
                    bold
                    to={getLink(relation.entityType, relation.entityId, relation.parentId, urlProvider, relation.subjectEntityType, relation.subjectEntityId)}
                >
                    {relation.entityName}
                </DotLegalLink>
            </Box>
        ));
    };

    return (
        <Box>
            <Box sx={styles.fieldLabel}>{translateString("relations")}:</Box>
            <Box sx={styles.fieldValue}>
                {platformFeatures.canAccessRelationsBetweenEntities ? (
                    getRelationNames()
                ) : (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        {PurpleLockIcon}
                        {translateString("upgradePrivacyPlanToday")}
                    </Box>
                )}
            </Box>
        </Box>
    );
}

export default OverviewRelationsField;
